import { jsx as r, jsxs as h } from "react/jsx-runtime";
import { useId as m } from "react";
import { W as d } from "../index-PMSPXTub.js";
import { c as o } from "../clsx-OuTLNxxd.js";
import '../List.css';const z = "_list_186i9_1", W = "_listItem_186i9_10", f = "_listItemText_186i9_16", k = "_iconWrapper_186i9_20", T = "_check_186i9_28", i = {
  list: z,
  listItem: W,
  listItemText: f,
  iconWrapper: k,
  check: T,
  "size--s": "_size--s_186i9_32",
  "size--m": "_size--m_186i9_44"
}, u = { s: "xsm", m: "sm" }, w = ({ classNames: t, direction: e, items: _, size: n = "m", ...p }) => {
  const c = m(), I = e ? { flexDirection: e } : {};
  return /* @__PURE__ */ r(
    "ul",
    {
      className: o(i.list, i[`size--${n}`], t == null ? void 0 : t.wrapper),
      "data-cxy-name": "list",
      style: I,
      ...p,
      children: _.map((x, l) => /* @__PURE__ */ h("li", { className: o(i.listItem, t == null ? void 0 : t.listItem), children: [
        /* @__PURE__ */ r("span", { className: o(i.iconWrapper, t == null ? void 0 : t.iconWrapper), children: /* @__PURE__ */ r(d, { className: o(i.check, t == null ? void 0 : t.checkIcon), color: "blue", size: u[n] }) }),
        /* @__PURE__ */ r("span", { className: o(i.listItemText, t == null ? void 0 : t.listItemText), children: x })
      ] }, `list-${c}-item-${l}`))
    }
  );
};
export {
  w as List
};
